import React from "react";
import "./ui.css";
import { AppColors } from "../utils/global-constants";
const MainButton = ({ text, onClick, loading, disabled, className }) => {
  return (
    <button
      className={`main-button ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={{ opacity: disabled ? 0.5 : 1 }}
    >
      {loading ? (
        <p style={{ color: AppColors.white }}>Loading...</p>
      ) : (
        <p style={{ color: AppColors.black }}>{text}</p>
      )}
    </button>
  );
};

export default MainButton;
